<template>
    <v-form :name="props.searchProps.formName"
            @keyup.enter="autoSearch = true">
        <TabView scrollable
                 style="overflow: visible"
                 :pt="{ panelContainer: { class: 'form-tab-panel' } }">
            <TabPanel :header="__('Search condition')"
                      headerClass="form-tab-header">
                <div class="grid">
                    <FormInputText fieldName="position_name"
                                   label="Position name"
                                   size="6"
                                   :isFocus="true"
                                   v-model:field="search.position_name" />

                    <FormInputText fieldName="symbol"
                                   label="Symbol"
                                   size="2"
                                   v-model:field="search.symbol" />

                    <FormInputText fieldName="position_sapid"
                                   label="SAP ID"
                                   size="2"
                                   v-model:field="search.position_sapid" />

                    <FormMultiselect fieldName="premium_id"
                                     label="Premium group"
                                     size="2"
                                     showClear
                                     :filtering="false"
                                     :options="select?.premium_symbols"
                                     v-model:field="search.premium_id" />
                </div>
            </TabPanel>
        </TabView>


        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import FormInputText from '@crud/FormInputText.vue'
import FormMultiselect from '@crud/FormMultiselect.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})
const autoSearch = ref(false)
const options = ["premium_symbols"];
const select = ref(null);

let search = ref({})
prepareSearch(search, props, options, select)

// -----------------------------------------------------

</script>

<style lang="scss"
       scoped></style>
